import AccountType from '@app/constants/AccountType'
import axios, { AxiosResponse } from 'axios'
import { $axios } from '@app/utils/api'
import firebase from 'firebase'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import {
  NormalAccountResponse,
  SalonAccountResponse,
  DeleteUserRequest,
  UpdateEmailRequest,
} from '@app/types/src/account'
import { Address } from '@app/types/src/Address'
import { AuthUser } from '@app/types/src/auth'
import Response from '@app/types/src/schema/Response'
import { accountModule, authModule } from '.'
import { Lang } from '@app/types/src/Lang'
import { setLang } from '@app/utils/checkLang'
import { safeErrorInfo } from '@app/utils/safeLog'

@Module({
  name: 'account',
  stateFactory: true,
  namespaced: true,
})
export default class AccountModule extends VuexModule {
  _account?: NormalAccountResponse | SalonAccountResponse

  @Mutation
  private setAccount(value: NormalAccountResponse | SalonAccountResponse) {
    this._account = value
  }
  // Objectはなぜかgetterメソッドじゃないと公開されない
  public get account() {
    return this._account
  }

  temporary_password_flag: string = ''
  @Mutation
  private setTemporaryPasswordFlag(value: string) {
    this.temporary_password_flag = value
  }
  // Objectはなぜかgetterメソッドじゃないと公開されない
  public get temporaryPasswordFlag() {
    return this.temporary_password_flag
  }

  isInitialize: boolean = false
  @Mutation
  private setIsInitialize(value: boolean) {
    this.isInitialize = value
  }
  accountType: AccountType = ''
  @Mutation
  setAccountType(value: AccountType) {
    this.accountType = value
  }

  name1: string = ''
  @Mutation
  setName1(value: string) {
    this.name1 = value
  }
  name2: string = ''
  @Mutation
  setName2(value: string) {
    this.name2 = value
  }
  name1Furigana: string = ''
  @Mutation
  setName1Furigana(value: string) {
    this.name1Furigana = value
  }

  name2Furigana: string = ''
  @Mutation
  setName2Furigana(value: string) {
    this.name2Furigana = value
  }
  password: string = ''
  @Mutation
  setPassword(value: string) {
    this.password = value
  }
  passwordConfirm: string = ''
  @Mutation
  setPasswordConfirm(value: string) {
    this.passwordConfirm = value
  }
  tel: string = ''
  @Mutation
  setTel(value: string) {
    this.tel = value
  }
  lineId: string = ''
  @Mutation
  setLineId(value: string) {
    this.lineId = value
  }
  email: string = ''
  @Mutation
  setEmail(value: string) {
    this.email = value
  }
  emailConfirm: string = ''
  @Mutation
  setEmailConfirm(value: string) {
    this.emailConfirm = value
  }
  zipcode: string = ''
  @Mutation
  setZipcode(value: string) {
    this.zipcode = value
  }

  address1: string = ''
  @Mutation
  setAddress1(value: string) {
    this.address1 = value
  }
  address2: string = ''
  @Mutation
  setAddress2(value: string) {
    this.address2 = value
  }
  address3: string = ''
  @Mutation
  setAddress3(value: string) {
    this.address3 = value
  }
  address4: string = ''
  @Mutation
  setAddress4(value: string) {
    this.address4 = value
  }
  salonName: string = ''
  @Mutation
  setSalonName(value: string) {
    this.salonName = value
  }
  salonNameFurigana: string = ''
  @Mutation
  setSalonNameFurigana(value: string) {
    this.salonNameFurigana = value
  }
  salonUrl: string = ''
  @Mutation
  setSalonUrl(value: string) {
    this.salonUrl = value
  }
  salonTel: string = ''
  @Mutation
  setSalonTel(value: string) {
    this.salonTel = value
  }
  salonZipcode: string = ''
  @Mutation
  setSalonZipcode(value: string) {
    this.salonZipcode = value
  }

  salonAddress1: string = ''
  @Mutation
  setSalonAddress1(value: string) {
    this.salonAddress1 = value
  }
  salonAddress2: string = ''
  @Mutation
  setSalonAddress2(value: string) {
    this.salonAddress2 = value
  }
  salonAddress3: string = ''
  @Mutation
  setSalonAddress3(value: string) {
    this.salonAddress3 = value
  }
  salonAddress4: string = ''
  @Mutation
  setSalonAddress4(value: string) {
    this.salonAddress4 = value
  }
  contract: number = 0
  @Mutation
  setContract(value: number) {
    this.contract = value
  }

  agreement: boolean = false
  @Mutation
  setAgreement(value: boolean) {
    this.agreement = value
  }

  corporateName: string = ''
  @Mutation
  setCorporateName(value: string) {
    this.corporateName = value
  }
  representative: string = ''
  @Mutation
  setRepresentative(value: string) {
    this.representative = value
  }

  //confirm等のリダイレクト制御用
  isInput: boolean = false
  @Mutation
  setIsInput(value: boolean) {
    this.isInput = value
  }

  //confirm等のリダイレクト制御用
  resendMailAddress: string = ''
  @Mutation
  setResendMailAddress(value: string) {
    this.resendMailAddress = value
  }

  importUserResendMailAddress: string = ''
  @Mutation
  setImportUserResendMailAddress(value: string) {
    this.importUserResendMailAddress = value
  }
  language: Lang = ''
  @Mutation
  setLanguage(value: Lang) {
    this.language = value
    try {
      setLang(value)
    } catch (e) {
      console.log(e)
    }
  }
  @Mutation
  clearAll() {
    this.accountType = ''
    this.name1 = ''
    this.name2 = ''
    this.name1Furigana = ''
    this.name2Furigana = ''
    this.password = ''
    this.passwordConfirm = ''
    this.tel = ''
    this.email = ''
    this.emailConfirm = ''
    this.zipcode = ''
    this.address1 = ''
    this.address2 = ''
    this.address3 = ''
    this.address4 = ''
    this.salonName = ''
    this.salonNameFurigana = ''
    this.salonTel = ''
    this.salonUrl = ''
    this.salonZipcode = ''
    this.salonAddress1 = ''
    this.salonAddress2 = ''
    this.salonAddress3 = ''
    this.salonAddress4 = ''
    this.corporateName = ''
    this.representative = ''
    this.agreement = false
    this._account = undefined
    this.temporary_password_flag = ''
    this.language = ''
    //resendMailAdressはクリアしない
  }
  @Action({ rawError: true })
  public deleteImportUser() {
    return new Promise<void>(async (resolve, reject) => {
      $axios
        .post(`${process.env.BASE_PATH_V3}/transfer-user/delete`)
        .then((result: Response<null>) => {
          resolve()
        })
        .catch((e) => {
          // 削除に失敗しても何もしない
          // reject(e)
        })
    })
  }
  @Action({ rawError: true })
  public sendMail() {
    return new Promise<void>(async (resolve, reject) => {
      $axios
        .post(
          `${process.env.BASE_PATH_V3}/transfer-user/send-import-account-info`,
          {
            email: this.importUserResendMailAddress,
          }
        )
        .then((result: Response<null>) => {
          console.log(result)
          resolve()
        })
        .catch((e) => {
          reject(e)
        })
    })
  }
  @Action({ rawError: true })
  public existImportUser(email: string) {
    return new Promise<boolean>(async (resolve, reject) => {
      const encodeEmail = encodeURIComponent(email)
      $axios
        .get(
          `${process.env.BASE_PATH_V3}/transfer-user/exist?email=${encodeEmail}`
        )
        .then((result: AxiosResponse<{ data: { exists: boolean } }>) => {
          resolve(result.data.data.exists)
        })
        .catch((e) => {
          reject(e)
        })
    })
  }

  @Action({ rawError: true })
  public searchAddress() {
    return new Promise<void>(async (resolve, reject) => {
      const response: any = await axios
        .get(`${process.env.BASE_PATH_V2}/v1/address?zipcode=${this.zipcode}`)
        .catch((e) => {
          reject(e)
          throw e
        })

      const address: Address = {
        pref: response.data[0].address1,
        city: response.data[0].address2 + response.data[0].address3,
      }
      this.setAddress1(address.pref)
      this.setAddress2(address.city)

      resolve()
    })
  }
  @Action({ rawError: true })
  public searchSalonAddress() {
    return new Promise<void>(async (resolve, reject) => {
      const response: any = await axios
        .get(
          `${process.env.BASE_PATH_V2}/v1/address?zipcode=${this.salonZipcode}`
        )
        .catch((e) => {
          reject(e)
          throw e
        })
      const address: Address = {
        pref: response.data[0].address1,
        city: response.data[0].address2 + response.data[0].address3,
      }
      this.setSalonAddress1(address.pref)
      this.setSalonAddress2(address.city)

      resolve()
    })
  }

  @Action({ rawError: true })
  public createFirebaseUser() {
    return new Promise<AuthUser>((resolve, reject) => {
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then((userCredential) => {
          const user = userCredential.user as AuthUser
          authModule.setAuthUser(user)
          resolve(user)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  @Action({ rawError: true })
  public async createUser() {
    console.log(this.language)
    let request: any = {
      account_type: this.accountType,
      email: authModule.email,
      name_1: this.name1,
      name_2: this.name2,
      furigana_1: this.name1Furigana,
      furigana_2: this.name2Furigana,
      tel: this.tel,
      line_id: this.lineId,
      language: this.language,
    }
    if (this.accountType == AccountType.indivisual) {
      request = {
        ...request,
        zip_code: this.zipcode,
        address_1: this.address1,
        address_2: this.address2,
        address_3: this.address3,
        address_4: this.address4,
      }
    }
    if (this.accountType == AccountType.salon) {
      request = {
        ...request,
        corporate_name: this.corporateName,
        representative: this.representative,
        salon_name: this.salonName,
        salon_name_furigana: this.salonNameFurigana,
        salon_url: this.salonUrl,
        salon_tel: this.salonTel,
        salon_zipcode: this.salonZipcode,
        salon_address_1: this.salonAddress1,
        salon_address_2: this.salonAddress2,
        salon_address_3: this.salonAddress3,
        salon_address_4: this.salonAddress4,
        contract: this.contract,
      }
    }
    await $axios
      .post(
        `${process.env.BASE_PATH_V2}/v1/user?lang=${this.language}`,
        request
      )
      .then((result) => {
        console.log(result)
      })
  }

  @Action({ rawError: true })
  public updateUser() {
    return new Promise<void>((resolve, reject) => {
      $axios
        .put(`${process.env.BASE_PATH_V2}/v1/user`, {
          name_1: this.name1,
          name_2: this.name2,
          furigana_1: this.name1Furigana,
          furigana_2: this.name2Furigana,
          zip_code: this.zipcode,
          address_1: this.address1,
          address_2: this.address2,
          address_3: this.address3,
          address_4: this.address4,
          line_id: this.lineId,
          tel: this.tel,
          language: this.language,
        })
        .then((result: AxiosResponse<Response<null>>) => {
          resolve()
        })
        .catch((e) => {
          reject(e)
        })
    })
  }

  @Action({ rawError: true })
  public updateSalonUser() {
    return new Promise<void>((resolve, reject) => {
      $axios
        .put(`${process.env.BASE_PATH_V2}/v1/user`, {
          name_1: this.name1,
          name_2: this.name2,
          furigana_1: this.name1Furigana,
          furigana_2: this.name2Furigana,
          corporate_name: this.corporateName,
          representative: this.representative,
          salon_name: this.salonName,
          salon_name_furigana: this.salonNameFurigana,
          salon_url: this.salonUrl,
          salon_zipcode: this.salonZipcode,
          salon_address_1: this.salonAddress1,
          salon_address_2: this.salonAddress2,
          salon_address_3: this.salonAddress3,
          salon_address_4: this.salonAddress4,
          line_id: this.lineId,
          tel: this.tel,
          salon_tel: this.salonTel,
          contract: this.contract,
          language: this.language,
        })
        .then((result: AxiosResponse<Response<null>>) => {
          resolve()
        })
        .catch((e) => {
          reject(e)
        })
    })
  }
  @Action({ rawError: true })
  public updateTemporaryPasswordFlag() {
    return new Promise<void>((resolve, reject) => {
      $axios
        .put(`${process.env.BASE_PATH_V2}/v1/user/temporary-password-flag`)
        .then((result: AxiosResponse<Response<null>>) => {
          this.setTemporaryPasswordFlag('0')
          resolve()
        })
        .catch((e) => {
          reject(e)
        })
    })
  }
  @Action({ rawError: true })
  public updateLanguage() {
    if (this.accountType != '') {
      return new Promise<void>((resolve, reject) => {
        $axios
          .put(`${process.env.BASE_PATH_V2}/v1/user/language`, {
            language: this.language,
          })
          .then((result: AxiosResponse<Response<null>>) => {
            resolve()
          })
          .catch((e) => {
            reject(e)
          })
      })
    }
  }
  @Action({ rawError: true })
  public updateEmail(payload: UpdateEmailRequest) {
    return new Promise<void>(async (resolve, reject) => {
      const currentUser = firebase!.auth().currentUser!
      const currentEmail = currentUser.email

      //最初にパスワード認証してパスワードが正しいものか確認する
      const credential = firebase.auth.EmailAuthProvider.credential(
        currentEmail!,
        payload.password
      )

      try {
        await currentUser.reauthenticateWithCredential(credential)
        const token = await currentUser?.getIdToken()

        console.log(`[Log]reauthenticateWithCredential`)
        authModule.setToken(token)
        authModule.setResendUpdateEmail(payload.email)
      } catch (e) {
        reject({ type: 1, message: '認証情報が正しくありません' })
        return
      }

      $axios
        .put(
          `${process.env.BASE_PATH_V2}/v1/auth/email?lang=${accountModule.language}`,
          {
            email: payload.email,
          }
        )
        .then(async () => {
          this.setEmail(payload.email)
          authModule.setEmailVerified(false)
          // await authModule.signOut()
          resolve()
        })
        .catch((e) => {
          reject({
            type: 2,
            message:
              '認証メールの送信に失敗しました。新しいメールアドレスで再ログインして、認証メールを再送信してください',
          })
        })
    })
  }

  @Action({ rawError: true })
  public deleteUser(payload: DeleteUserRequest) {
    return new Promise<Response<null>>(async (resolve, reject) => {
      try {
        // 再認証
        const currentUser = firebase.auth().currentUser
        // メールアドレスはログに出さない
        console.log(`[Log] CurrentUser`, !!currentUser)

        if (currentUser?.email !== payload.email) {
          reject()
          return
        }
        const credential = firebase.auth.EmailAuthProvider.credential(
          currentUser?.email!,
          payload.password
        )
        // 再認証は必ず完了を待つ。待たずに DELETE を送ると、再認証の失敗（reject）と
        // サーバー側の退会完遂が競合し、退会できているのに失敗扱いになる（0096）。
        // 失敗したら DELETE は呼ばない（退会は再認証に成功したときだけ行う）
        try {
          await currentUser?.reauthenticateWithCredential(credential)
        } catch (e: any) {
          // e 全体は出さない（message に個人情報が入りうる）。code だけ残す
          console.log(`[Log]再認証エラー`)
          console.error('[Log]再認証エラー', safeErrorInfo(e))
          reject(e)
          return
        }
        console.log(`[Log]再認証完了`)

        // 退会は V3 の BFF に一本化されている（0096）。
        // Kintone の退会更新 → Firebase アカウントの削除 → 退会メールまでをサーバーが行うので、
        // ここでは currentUser.delete() を呼ばない。サーバーが 4xx / 5xx を返したら reject する
        $axios
          .delete(`${process.env.BASE_PATH_V3}/user/self`)
          .then(async (result: AxiosResponse<Response<null>>) => {
            console.log(`[Log]退会完了`)
            // サーバーが Firebase のアカウントを消すので、この端末に残る認証セッションだけを破棄する
            // （currentUser.delete() が暗黙に行っていたログアウト相当。失敗しても退会の成否には影響させない）
            try {
              await firebase.auth().signOut()
            } catch (signOutError) {
              console.log(
                `[Log]ローカルのログアウトに失敗`,
                safeErrorInfo(signOutError)
              )
            }
            resolve(result.data)
          })
          .catch((e) => {
            console.log(`[Log]退会エラー`)
            reject(e)
          })
      } catch (e) {
        //reauthenticateAndRetrieveDataWithCredential のエラー
        console.log(`[Log]再認証削除エラー`)
        console.error('[Log]再認証削除エラー', safeErrorInfo(e))
        reject(e)
      }
    })
  }

  @Action({ rawError: true })
  public getUser(reflesh: boolean = false) {
    return new Promise<NormalAccountResponse | SalonAccountResponse>(
      (resolve, reject) => {
        //if (reflesh && this.account) resolve(this.account)

        $axios
          .get(`${process.env.BASE_PATH_V2}/v1/user`)
          .then(
            (
              result: AxiosResponse<
                Response<NormalAccountResponse | SalonAccountResponse>
              >
            ) => {
              const account: NormalAccountResponse | SalonAccountResponse =
                result.data.data!

              this.setAccount({
                ...account,
              })
              this.setAccountType(account.account_type)
              this.setIsInitialize(true)
              this.setName1(account.name_1)
              this.setName2(account.name_2)
              this.setName1Furigana(account.furigana_1)
              this.setName2Furigana(account.furigana_2)
              this.setLineId(account.line_id)
              this.setEmail(account.email)
              this.setTel(account.tel)
              this.setTemporaryPasswordFlag(account.temporary_password_flag)
              this.setLanguage(account.language)
              if (account.account_type === AccountType.indivisual) {
                const normalAccount = account as NormalAccountResponse

                this.setZipcode(normalAccount.zip_code)
                this.setAddress1(normalAccount.address_1)
                this.setAddress2(normalAccount.address_2)
                this.setAddress3(normalAccount.address_3)
                this.setAddress4(normalAccount.address_4)
                resolve(normalAccount)
              } else {
                const salonAccount = account as SalonAccountResponse
                this.setCorporateName(salonAccount.corporate_name)
                this.setRepresentative(salonAccount.representative)
                this.setSalonName(salonAccount.salon_name)
                this.setSalonNameFurigana(salonAccount.salon_name_furigana)
                this.setSalonTel(salonAccount.salon_tel)
                this.setSalonUrl(salonAccount.salon_url)
                this.setSalonZipcode(salonAccount.salon_zipcode)
                this.setSalonAddress1(salonAccount.salon_address_1)
                this.setSalonAddress2(salonAccount.salon_address_2)
                this.setSalonAddress3(salonAccount.salon_address_3)
                this.setSalonAddress4(salonAccount.salon_address_4)
                this.setContract(salonAccount.contract)
                resolve(salonAccount)
              }
            }
          )
          .catch((e) => {
            reject(e)
          })
      }
    )
  }
}
